<template>
  <div class="table-settings">
    <h1 class="settings-title">
      Teams
    </h1>
    <button
      class="btn btn-main btn-round mb-3"
      @click="openTeamModal()">Create New Team</button>


    <b-table
      :fields="fields"
      :items="teams"
      show-empty
      responsive
      class="merchant-dashboard__table scroll-area-horizontal">

      <!-- Name column -->
      <template v-slot:cell(name)="data">
        {{ data.item.name }}
      </template>

      <!-- Members column -->
      <template v-slot:cell(members)="data">
        <span
          class="sub-button"
          @click="openTeamModal(data.item)">
          {{ data.item.users.length }} members</span>
      </template>

      <!-- Actions column -->
      <template v-slot:cell(actions)="data">
        <b-dropdown
          right
          no-flip
          no-caret
          class="actions">
          <!-- button -->
          <template v-slot:button-content>
            <icon name="ellipsis-h"/>
          </template>
          <!-- Items -->
          <b-dropdown-item @click="openTeamModal(data.item)">
            Edit Team
          </b-dropdown-item>
          <b-dropdown-item
            :disabled="data.item.main"
            @click="openDeleteTeamModal(data.item)">
            Delete
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <!-- No data content -->
      <template v-slot:empty="">
        <div
          v-if="!teams.length && !teamsLoaded"
          slot="empty"
          class="loader">
          <div class="loading-circle"/>
        </div>
      </template>
    </b-table>

    <TeamModal
      ref="teamModal"
      :teamp="selectedTeam"
      @saved="fetchTeams($route.params.merchant_id)"/>
    <TeamDeleteModal
      ref="teamDeleteModal"
      :teamp="selectedTeam"
      @deleted="fetchTeams($route.params.merchant_id)"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TeamModal from './modals/TeamModal';
import TeamDeleteModal from './modals/TeamDeleteModal';

export default {
  name: 'TeamSettings',
  components: {
    TeamModal,
    TeamDeleteModal,
  },
  data() {
    return {
      fields: [
        'name',
        {
          key: 'members',
          class: 'text-underline',
        },
        {
          key: 'actions',
          class: 'text-right',
        },
      ],
      selectedTeam: {},
    };
  },
  computed: {
    ...mapGetters({
      teams: 'team/teamList',
      teamsLoaded: 'team/teamsLoaded',
      apiError: 'team/apiError',
    }),
  },
  mounted() {
    this.fetchTeams(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      fetchTeams: 'team/fetchTeamList',
    }),
    openTeamModal(team = {}) {
      this.selectedTeam = team;
      this.$nextTick(() => {
        this.$refs.teamModal.show();
      });
    },
    openDeleteTeamModal(team) {
      this.selectedTeam = team;
      this.$refs.teamDeleteModal.show();
    },
  },
};
</script>
